import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { Button } from "./ui/button";
import { ChevronsUpDown, Search } from "lucide-react";

const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
// Ogni parola digitata deve comparire (in qualsiasi ordine) in tipologia, codice o descrizione.
const smartFilter = (value, search) => (norm(search).split(/\s+/).filter(Boolean).every((t) => norm(value).includes(t)) ? 1 : 0);

export function ListinoPicker({ listino, value, onChange, eur }) {
  const [open, setOpen] = useState(false);
  const sel = listino.find((x) => x.codice === value);
  const groups = listino.reduce((acc, x) => { (acc[x.tipologia || "Altro"] ||= []).push(x); return acc; }, {});
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 w-[360px] justify-between text-xs font-normal" data-testid="listino-pick">
          <span className="truncate">{sel ? `${sel.tipologia} · ${sel.codice} · ${eur(sel.prezzo_riservato)}` : "Articolo a listino (prezzo riservato)…"}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 opacity-60 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[460px] p-0" align="start">
        <Command filter={smartFilter}>
          <CommandInput placeholder="Cerca per codice, tipologia o descrizione (es. ev 22k)…" data-testid="listino-search" />
          <CommandList className="max-h-80">
            <CommandEmpty><span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"><Search className="h-3.5 w-3.5" /> Nessun articolo trovato</span></CommandEmpty>
            {Object.entries(groups).map(([tip, items]) => (
              <CommandGroup key={tip} heading={tip}>
                {items.map((x) => (
                  <CommandItem key={x.codice} value={`${x.tipologia} ${x.codice} ${x.descrizione || ""}`} onSelect={() => { onChange(x.codice); setOpen(false); }} data-testid={`listino-opt-${x.codice}`}>
                    <div className="flex w-full items-center justify-between gap-3">
                      <div className="min-w-0">
                        <div className="text-xs font-medium">{x.codice}</div>
                        {x.descrizione && <div className="text-[11px] text-muted-foreground truncate">{x.descrizione}</div>}
                      </div>
                      <span className="text-xs font-semibold shrink-0">{eur(x.prezzo_riservato)}</span>
                    </div>
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
